// TODO: remove this component, instead use popover in next-ui@6
import * as tslib_1 from "tslib";
import { omit } from '@nextiva/analytics-common';
import cx from 'classnames';
import * as React from 'react';
import { Popover } from '@nextiva/next-ui';
import Styles from "./AnalyticsPopover.css";

var AnalyticsPopover =
/** @class */
function (_super) {
  tslib_1.__extends(AnalyticsPopover, _super);

  function AnalyticsPopover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: _this.props.isOpen
    };

    _this.togglePopover = function () {
      var isOpen = !_this.state.isOpen;

      _this.setState({
        isOpen: isOpen
      });

      if (_this.props.onToggle) {
        _this.props.onToggle(isOpen);
      }
    };

    _this.renderTarget = function (isOpen) {
      var children = _this.props.children; //@ts-ignore

      return typeof children === 'function' ? children({
        isOpen: isOpen
      }) : children;
    };

    _this.renderBody = function () {
      var body = _this.props.body;

      if (typeof body === 'function') {
        // @ts-ignore
        return body({
          togglePopover: _this.togglePopover
        });
      }

      return body;
    };

    return _this;
  }

  AnalyticsPopover.prototype.componentWillReceiveProps = function (nextProps) {
    if (this.props.isOpen !== nextProps.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  };

  AnalyticsPopover.prototype.render = function () {
    var isOpen = this.state.isOpen;

    var _a = this.props,
        className = _a.className,
        otherProps = tslib_1.__rest(_a, ["className"]);

    return React.createElement(Popover, tslib_1.__assign({
      isOpen: isOpen,
      togglePopover: this.togglePopover,
      body: this.renderBody(),
      className: cx(Styles.popover, className)
    }, omit(otherProps, ['isOpen', 'body', 'children'])), this.renderTarget(isOpen));
  };

  AnalyticsPopover.defaultProps = {
    isOpen: false
  };
  return AnalyticsPopover;
}(React.PureComponent);

export default AnalyticsPopover;